import React from "react";
import { withRouter } from "react-router-dom/cjs/react-router-dom";

function OrganizationSettings(props) {
	return <div></div>;
}
export default withRouter(OrganizationSettings);
